/* eslint-disable consistent-return */
import { Form, ImageContent, MapCard, OpenCard, SubitleCard, TitleCard } from './styles';
import React, { useContext, useRef, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { FrameData } from '../../components/FrameData';
import { AutoRow } from 'components/AutoRow';
import IframeContext, { IIframeContext } from 'contexts/IframeContext';
import { ActionTitle } from 'components/AutoRow/components/ActionTitle';
import { IMapContainer, Map } from 'components/Map';
import { CardHistory } from 'components/CardHistory';
import { FaClock, FaPeopleCarryBox, FaUserCheck } from 'react-icons/fa6';

const IframeOcorrencia = ({ history }: RouteComponentProps) => {
  const [mapLatLng, setMapLatLng] = useState<[number, number]>([-1.440077, -48.471985]);
  const mapElement = useRef<IMapContainer>();
  const { dadosConsultaAreaColeta, handleBuscarAreaColeta, setDadosConsultaAreaColeta } = useContext<IIframeContext>(
    IframeContext,
  );

  const { loading, enderecoBuscado } = dadosConsultaAreaColeta;

  const handleSearch = async () => {
    const success = await handleBuscarAreaColeta();

    if (success) history.push('/coleta');
  };

  return (
    <FrameData>
      <Form id="form-busca" onSubmit={(e) => e.preventDefault()}>
        <AutoRow>
          <ActionTitle label="Ocorrência" />

          <OpenCard>
            <TitleCard>Detalhes da ocorrência</TitleCard>
            <SubitleCard>
              <b>Protocolo:</b> 82783263128
            </SubitleCard>
            <SubitleCard>
              <b>Data de abertura:</b> 06/01/2025 23:34
            </SubitleCard>
            <SubitleCard>
              <b>Prazo:</b> Atendido
            </SubitleCard>
            <SubitleCard>
              <b>Motivo:</b> Lâmpada queimada
            </SubitleCard>
            <SubitleCard>
              <b>Endereço:</b> Av. Assis Chateaubriand, 180 - Prado, Maceió - AL, 57020-755, Brasil
            </SubitleCard>
          </OpenCard>
          <OpenCard>
            <TitleCard>Mais informações</TitleCard>
            <ImageContent>
              <img />
              <img />
            </ImageContent>
          </OpenCard>
          <OpenCard>
            <TitleCard>Histórico</TitleCard>
            <CardHistory title="Ocorrência registrada" subtitle="Dia 12/02/2000 às 12:12">
              <FaUserCheck />
            </CardHistory>
            <CardHistory title="Encaminhado para a equipe técnica" subtitle="Dia 12/02/2000 às 12:12" lined>
              <FaPeopleCarryBox />
            </CardHistory>
            <CardHistory title="Prazo final" subtitle="Dia 12/02/2000 às 12:12" lined>
              <FaClock />
            </CardHistory>
          </OpenCard>
          <MapCard>
            <Map
              scrollWheelZoom
              doubleClickZoom={false}
              zoom={14}
              coords={mapLatLng}
              refMapElement={mapElement}
              maxZoom={30}
            />
          </MapCard>
        </AutoRow>
      </Form>
    </FrameData>
  );
};

export default IframeOcorrencia;
